import { render } from "./VerifyAccountPage.vue?vue&type=template&id=5dcbf8f2&scoped=true"
import script from "./VerifyAccountPage.vue?vue&type=script&lang=js"
export * from "./VerifyAccountPage.vue?vue&type=script&lang=js"

import "./VerifyAccountPage.vue?vue&type=style&index=0&id=5dcbf8f2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dcbf8f2"]])

export default __exports__